import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Button from '@atoms/Button';
import ModalBase from '@molecules/ModalBase';
import { BodyLarge, ButtonPrimaryLarge, H2 } from '@react/styledComponents';
import { mediaQueries } from '@general/breakpoints';

const ButtonContainerStyled = styled.div`
    margin-top: 1.875rem;

    button {
        width: 100%;

        &:not(:first-child) {
            margin-top: 1rem;
        }
    }

    @media ${mediaQueries.lg} {
        display: flex;

        button {
            width: auto;

            &:not(:first-child) {
                margin-left: 1rem;
                margin-top: 0;
            }
        }
    }
`;

const ConfirmationModal = ({
    bodyText,
    cancelButtonText = 'Cancel',
    confirmButtonText = 'Confirm',
    headingText,
    isOpen,
    onClose,
    onConfirm,
}) => {
    return (
        <ModalBase
            isOpen={isOpen}
            stylesBody={{
                paddingBottom: '64px',
                paddingLeft: '64px',
                paddingRight: '64px',
                paddingTop: '24px',
            }}
            onClose={onClose}
        >
            <H2>{headingText}</H2>
            <BodyLarge className="mt-1.875rem">{bodyText}</BodyLarge>
            <ButtonContainerStyled>
                <Button onClick={() => onConfirm()}>{confirmButtonText}</Button>
                <ButtonPrimaryLarge onClick={onClose}>{cancelButtonText}</ButtonPrimaryLarge>
            </ButtonContainerStyled>
        </ModalBase>
    );
};

ConfirmationModal.propTypes = {
    bodyText: PropTypes.string.isRequired,
    cancelButtonText: PropTypes.string,
    confirmButtonText: PropTypes.string,
    headingText: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default ConfirmationModal;
